// Client-side image resizing utilities
export const resizeImageClient = (file: File, maxWidth: number, minWidth: number, aspectRatioRange: [number, number]) => {
  return new Promise<File>((resolve) => {
    const img = new window.Image();
    img.src = URL.createObjectURL(file);

    img.onload = () => {
      const { width, height } = img;
      const aspectRatio = width / height;

      // Ensure aspect ratio is within the allowed range
      let newWidth = width;
      let newHeight = height;

      if (aspectRatio < aspectRatioRange[1]) {
        newHeight = newWidth / (4 / 5); // Crop height for 4:5 aspect ratio
      } else if (aspectRatio > aspectRatioRange[0]) {
        newWidth = newHeight * 1.91; // Crop width for 1.91:1 aspect ratio
      }

      if (newWidth > maxWidth) {
        newHeight = (maxWidth / newWidth) * newHeight;
        newWidth = maxWidth;
      } else if (newWidth < minWidth) {
        newHeight = (minWidth / newWidth) * newHeight;
        newWidth = minWidth;
      }

      // Resize and compress the image
      const canvas = document.createElement('canvas');
      canvas.width = newWidth;
      canvas.height = newHeight;

      const ctx = canvas.getContext('2d');
      ctx?.drawImage(img, 0, 0, newWidth, newHeight);

      canvas.toBlob(
        (blob) => {
          if (blob) {
            resolve(new File([blob], file.name, { type: 'image/webp' }));
          }
        },
        'image/webp',
        0.8, // Quality set to 80%
      );
    };
  });
};
